export default "__VITE_ASSET__0fe438b5__"